import { SVCFacturacion } from "../../infrastructure/services/api/SVCFacturacion";

export const ObtieneDocumentoPorAlumno = (
    selListaDocumentoFacturacion: any,
    headers: any,
    rut: number, codigoNegocio: number,
    codigoPrograma: string,
    codigoPlanificacion: number,
    agno: number,
    periodo: number,
    idPeriodo: number) => {
    let list: any;
    SVCFacturacion.ObtieneDocumentoPorAlumno(
        headers,
        rut,
        codigoNegocio,
        codigoPrograma,
        codigoPlanificacion,
        agno,
        periodo,
        idPeriodo
    ).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            selListaDocumentoFacturacion(false, '', data);
        } else {
            selListaDocumentoFacturacion(true, res.errorDetails, list);
        }
    });
}

export const ObtieneDatosFacturacion = (
    selCargarDatosFacturacion: any,
    headers: any,
    RutFacturacion: string
) => {
    SVCFacturacion.ObtieneDatosFacturacion(
        headers,
        RutFacturacion
    ).then((res: any) => {
        if (res.result !== undefined) {
            selCargarDatosFacturacion(false, '', res.result);
        } else {
            selCargarDatosFacturacion(true, res.errorDetails, res.result);
        }
    });
};

export const ObtieneDatosPersonales = (
    selCargarDatosPersonales: any,
    RutFacturacion: string,
    headers: any
) => {
    SVCFacturacion.ObtieneDatosPersonales(
        RutFacturacion, headers
    ).then((res: any) => {
        if (res.result !== undefined) {
            selCargarDatosPersonales(false, '', res.result);
        } else {
            selCargarDatosPersonales(true, res.errorDetails, res.result);
        }
    });
};

//////////////////////////////////////////////////////////

export const GrabarFacturacion = (
    selGrabarDatosFacturacion: any,
    IdProcesoPostulante: number,
    RutFacturacionSF: number,
    DV: string,
    Giro: string,
    RazonSocial: string,
    CorreoFacturacion: string,
    Telefono: string,
    Direccion: string,
    IDComuna: number,
    DatosAlumno: boolean
) => {
    SVCFacturacion.GrabarFacturacion(
        IdProcesoPostulante,
        RutFacturacionSF,
        DV,
        Giro,
        RazonSocial,
        CorreoFacturacion,
        Telefono,
        Direccion,
        IDComuna,
        DatosAlumno
    ).then((res: any) => {
        if (res.result !== undefined) {
            selGrabarDatosFacturacion(false, '', res.result);
        } else {
            selGrabarDatosFacturacion(true, res.errorDetails, res.result);
        }
    });
};

export const Get_FacturacionInfoMatricula = (
    SelGetFacturacionInfoMatricula: any,
    IdProcesoPostulante: number,
    RutFacturacion: number
) => {
    SVCFacturacion.Get_FacturacionInfoMatricula(
        IdProcesoPostulante,
        RutFacturacion
    ).then((res: any) => {
        if (res.result !== undefined) {
            SelGetFacturacionInfoMatricula(false, '', res.result);
        } else {
            SelGetFacturacionInfoMatricula(true, res.errorDetails, res.result);
        }
    });
};

export const Del_FacturacionInfoMatricula = (
    SelDelFacturacionInfoMatricula: any,
    IdProcesoPostulante: number
) => {
    SVCFacturacion.Del_FacturacionInfoMatricula(
        IdProcesoPostulante
    ).then((res: any) => {
        if (res.result !== undefined) {
            SelDelFacturacionInfoMatricula(false, '', res.result);
        } else {
            SelDelFacturacionInfoMatricula(true, res.errorDetails, res.result);
        }
    });
};

